import { Button, Col, Input, Row } from "reactstrap"
import LightGrayBgWrapper from "../../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import BackButton from "../../../../../components/common/BackButton/BackButton"
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper"
import ReactQuill from "react-quill"
import { useState } from "react"

const CreateCustomPage = () => {
  const [content, setContent] = useState(``)

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['link', 'image', 'video', 'formula'],
  
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
  
    ['clean']                                         // remove formatting button
  ];

  return (
    <LightGrayBgWrapper>
      <BackButton />
      <div className="fw-semibold fs-5">Create Custom Page</div>

      <Row>
        <Col>
          <YellowHeaderWrapper title="Title">
            <Row className="align-items-center">
              <Col xs="2">
                <div>Page Title:</div>
              </Col>
              <Col>
                <Input type="text" placeholder="Enter name of the page" />
              </Col>
            </Row>
          </YellowHeaderWrapper>
          <YellowHeaderWrapper title="Title">
            <div className="fw-semibold">Details:</div>
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              placeholder="Add data"
              // className={styles.codeEditor}
              modules={{ toolbar: toolbarOptions }}
            />

            <div className="fw-semibold">Make Content using AI</div>
            <Row className="g-0 gx-2">
              <Col>
                <Input type="textarea" rows='10' />
              </Col>
              <Col xs="auto">
                <Button color="info">Generate</Button>
                <div className="d-flex flex-column gap-1 ms-3 mt-2">
                  <div className="cursor-pointer">Copy</div>
                  <div className="cursor-pointer">Rephrase</div>
                  <div className="cursor-pointer">Extend</div>
                </div>
              </Col>
            </Row>
          </YellowHeaderWrapper>
        </Col>
        <Col>
          <div className="d-flex align-items-center justify-content-end gap-2">
            <div className="cursor-pointer">Cancel</div>
            <Button color="info">Save Changes</Button>
          </div>

          <div className="fw-semibold">Page Preview</div>

          <div className="shadow bg-white mt-2 ql-editor" style={{ height: '700px', minHeight: '500px' }} dangerouslySetInnerHTML={{ __html: content }} />
        </Col>
      </Row>
    </LightGrayBgWrapper>
  )
}

export default CreateCustomPage
